module.exports = __webpack_public_path__ + "94e06471de0101145448e1e2898667d6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/average.svg
// module id = 391
// module chunks = 0